import { Paper, Box, Typography, alpha } from '@mui/material';
import Grid2 from '@mui/material/Grid2'; // Ajuste o import do Grid2 se necessário
import { CheckCircle, Cancel, AccessTime, Groups } from '@mui/icons-material';

type PaletteColorKey = 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';

interface SummaryCardsProps {
  presente: number;
  ausente: number;
  atrasado: number;
  total: number;
}

export function SummaryCards({ presente, ausente, atrasado, total }: SummaryCardsProps) {
  const cards: Array<{ label: string; value: number; color: PaletteColorKey; icon: JSX.Element }> = [
    { label: "Presentes", value: presente, color: "success", icon: <CheckCircle color="success" fontSize="small" /> },
    { label: "Ausentes", value: ausente, color: "error", icon: <Cancel color="error" fontSize="small" /> },
    { label: "Atrasados", value: atrasado, color: "warning", icon: <AccessTime color="warning" fontSize="small" /> },
    { label: "Total", value: total, color: "primary", icon: <Groups color="primary" fontSize="small" /> },
  ];

  return (
    <Grid2 container spacing={3}>
      {cards.map((card) => (
        <Grid2 key={card.label} size={{ xs: 6, sm: 3 }}>
          <Paper 
            elevation={0} 
            sx={{ 
              p: 2, 
              display: 'flex', 
              alignItems: 'center', 
              gap: 2, 
              borderRadius: 3,
              bgcolor: (theme) => alpha(theme.palette[card.color].main, 0.05),
              border: '1px solid',
              borderColor: (theme) => alpha(theme.palette[card.color].main, 0.2),
              height: '100%' 
            }}
          >
            <Box sx={{ display: 'flex', p: 1, borderRadius: 2, bgcolor: (theme) => alpha(theme.palette[card.color].main, 0.1) }}>
              {card.icon}
            </Box>
            <Box>
              <Typography variant="h5" fontWeight="bold" sx={{ color: `${card.color}.main`, lineHeight: 1 }}>
                {card.value}
              </Typography>
              <Typography variant="caption" color="text.secondary" fontWeight="medium">
                {card.label}
              </Typography>
            </Box>
          </Paper>
        </Grid2>
      ))}
    </Grid2>
  );
}